module.exports = __webpack_public_path__ + "static/media/五十音速成课.original.2cd7e38d.png";